import { Inject } from "inversify-props";
import type { CashbackCrmBonusServiceAdapter } from "./adapter";
import { CashbackCrmBonusAvailableResponse, CashbackCrmBonusCampanhasResponse, CashbackCrmBonusFinalizacaoResponse, CashbackCrmBonusPINResponse, CashbackCrmBonusTokenResponse } from "@/models/Cashback";

export class CashbackCrmBonusUseCase {
	@Inject('CashbackCrmBonusServiceAdapter')
	private cashbackCrmBonusServiceAdapter!: CashbackCrmBonusServiceAdapter

	possuiPluginCrmBonusConfigurado = async (lojaId: string): Promise<boolean> => 
		await this.cashbackCrmBonusServiceAdapter.possuiPluginCrmBonusConfigurado(lojaId)

	validarToken = async (lojaId: string): Promise<CashbackCrmBonusTokenResponse> =>
		await this.cashbackCrmBonusServiceAdapter.validarToken(lojaId)

	enviarPINParaCliente = async (cnpjOuCpfCliente: string, lojaId: string, valor: number, itens: any): Promise<CashbackCrmBonusPINResponse> =>
		await this.cashbackCrmBonusServiceAdapter.enviarPINParaCliente(cnpjOuCpfCliente, lojaId, valor, itens)

	reenviarPINParaCliente = async (cnpjOuCpfCliente: string, params: any): Promise<CashbackCrmBonusPINResponse> =>
		await this.cashbackCrmBonusServiceAdapter.reenviarPINParaCliente(cnpjOuCpfCliente, params)

	validarPINInformado = async (params: any, pin: string): Promise<CashbackCrmBonusPINResponse> => 
		await this.cashbackCrmBonusServiceAdapter.validarPINInformado(params, pin)

	consultaCashbackCrmBonusCliente = async (userId: string, requestHash: string, lojaId: string, valor: number, params: any): Promise<CashbackCrmBonusAvailableResponse> =>
		await this.cashbackCrmBonusServiceAdapter.consultaCashbackCrmBonusCliente(userId, requestHash, lojaId, valor, params)

	consultarCampanhasDisponiveisCrmBonus = async (params: any): Promise<CashbackCrmBonusCampanhasResponse[]> =>
		await this.cashbackCrmBonusServiceAdapter.consultarCampanhasDisponiveisCrmBonus(params)

	finalizarVendaCashbackCrmBonus = async (params: any, campanhaId: string, pinMaster: boolean): Promise<CashbackCrmBonusFinalizacaoResponse> =>
		await this.cashbackCrmBonusServiceAdapter.finalizarVendaCashbackCrmBonus(params, campanhaId, pinMaster)

	enviarVendaCrmBonus = async (params: any): Promise<string> =>
		await this.cashbackCrmBonusServiceAdapter.enviarVendaCrmBonus(params)

	cancelarCrmBonus = async (vendaId: string, lojaId: string) =>
		await this.cashbackCrmBonusServiceAdapter.cancelarCrmBonus(vendaId, lojaId)
}